import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromCompetition from '../reducers/competitions.reducer';
export const selectCompetitionState = createFeatureSelector<fromCompetition.State>('competitions');
export const selectCompetitions = createSelector(
  selectCompetitionState,
  (state: fromCompetition.State) => state.competitions
);
export const selectCompetitionErrorMessage = createSelector(
  selectCompetitionState,
  (state: fromCompetition.State) => state.errorMessage
);
export const selectIsCompetitionLoading = createSelector(
  selectCompetitionState,
  (state: fromCompetition.State) => state.isLoading
);
